import React from 'react'
import agent1 from './agent1.jpeg'
import { Link } from 'react-router-dom'

const Become=()=> {
  return (
    <div>
      <>
      <div id='become' className=''>

     
      <div className='container my-3'>
        <div className='row'>
            <div className='col-md-6'>
                <img src={agent1} className='animated' alt=''/>

            </div>
            <div className='col-md-6'>
                <h1>Become a LIC Agent</h1>
                <p>Professional Training Through Seminars, Sponsorship for special Training Programs, Knowledge Dissemination of all LIC products, Transparency operations, Best practices in the industry, Excellent claim settlement ratio, Sovereign guarantee to customers.

</p>
<div className='mt-3'>
                <Link to='/Displayform' className='btn btn-success'>Apply now</Link>

              </div>

            </div>

        </div>
        </div>

      </div>
      </>
    </div>
  )
}

export default Become
